module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis2-4360f2425b37d823f7599aaee2e130a9.jpg";